import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export function TokenGuard({ children }) {
  const { isAuthenticated, tokenValid, checkTokenValidity, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const validate = async () => {
      if (!isAuthenticated) {
        navigate('/login');
        return;
      }
      
      const valid = await checkTokenValidity();
      if (!valid) {
        navigate('/login');
      }
    };
    
    if (!loading) {
      validate();
    }
  }, [isAuthenticated, loading, navigate, checkTokenValidity]);

  if (loading) return null;
  return children;
}
